import { render, staticRenderFns } from "./BasicRaceTrait.vue?vue&type=template&id=98d00df6&scoped=true&"
import script from "./BasicRaceTrait.vue?vue&type=script&lang=js&"
export * from "./BasicRaceTrait.vue?vue&type=script&lang=js&"
import style0 from "./BasicRaceTrait.vue?vue&type=style&index=0&id=98d00df6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98d00df6",
  null
  
)

export default component.exports